import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../../utils';

import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Loader from '../utils/Loader';
import HomeSkeleton from '../utils/HomeSkeleton';

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            isLogin() === false && restricted ?
                <Redirect to="/" />
            : <><Header {...props}/><Suspense fallback={props.location.pathname === '/' ? <HomeSkeleton /> : <Loader />}><Component {...props} /></Suspense><Footer {...props}/></>
        )} />
    );
};

export default PublicRoute;
